export const PAY_NOW_LABEL = (
  cardName: string,
  earnMultiplier: number,
  rewardCurrency: string
) =>
  `Pay today with your ${cardName} card and earn ${earnMultiplier}X ${rewardCurrency}`;
export const PAY_LATER_LABEL = (
  cardName: string,
  payLaterMultiplier: number,
  rewardCurrency: string
) =>
  `Pay at hotel with your ${cardName} card and earn ${payLaterMultiplier}X ${rewardCurrency}`;
export const PAY_LATER_NOTES =
  "Please note that miles, travel credits and offers can’t be applied to the booking when paying at the hotel.";
export const SELECT_WHEN_TO_PAY = "Select when you'd like to pay";
export const SUBTITLE =
  "Enjoy the same cancellation policy and premium benefits with either option.";
export const CONTINUE = "Continue";
